import React from 'react';
import './UtilitiesDevelopment.css';

const WaterAndElectricity = () => {
  return (
    <section className="utilities">
      <div className="utilities-wrapper">
        <h2 className="utilities-section-title">Water & Electricity Projects</h2>
        <div className="utilities-grid">
          <div className="utilities-card">
            <h3>Water Supply Initiatives</h3>
            <p>
              Installation of new boreholes in remote areas to provide clean and safe drinking water, alongside the rehabilitation of broken water systems in key communities.
            </p>
          </div>
          <div className="utilities-card">
            <h3>Electricity Access Expansion</h3>
            <p>
              Electrification projects have extended power lines to underserved villages, with solar-powered street lights installed for security and night-time mobility.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WaterAndElectricity;